export default "__VITE_ASSET__DWTPJij7__"